import { ArrowRightAlt } from "@mui/icons-material";
import {
  Avatar,
  Box,
  CircularProgress,
  Stack,
  Typography,
} from "@mui/material";
import React from "react";
import { Dot, SelectedDot } from "../../Icons";
import {
  appOptionsStyles,
  cardStyles,
  containerStyles,
  daySelectionItemStyles,
  scanButtonInnerStyles,
  scanButtonWrapperStyles,
  selectedDayStyles,
  summaryPanelStyles,
  toDoCardStyles,
} from "../../style";
import { useAppSelector } from "../../../../../Redux/hooks";
import MobileMockup from "../../../../Common/UI/MobileMockup";

const HomeScreenPreview = () => {
  const previewData = useAppSelector((state) => state.appCustomization.data);
  const loading = useAppSelector((state) => state.appCustomization.loading);

  return (
    <Box sx={containerStyles}>
      <Stack sx={{ p: 2.5 }} justifyContent={"center"} direction={"row"}>
        <MobileMockup width={350}>
          <Stack sx={cardStyles} justifyContent="space-between">
            {!loading ? (
              <>
                <>
                  <Stack direction={"row"} sx={{ px: 2, pt: 2 }}>
                    <Stack alignItems={"flex-start"}>
                      <Typography variant="h6" fontWeight={"bold"}>
                        Hi, Patient
                      </Typography>
                      <Typography variant="body1" color={"gray"}>
                        Have a healthy morning!
                      </Typography>
                    </Stack>
                    <Stack
                      sx={{ marginLeft: "auto" }}
                      direction={"row"}
                      gap={1}
                    >
                      <Avatar sx={{ width: "20px", height: "20px" }} />
                      <Avatar sx={{ width: "20px", height: "20px" }} />
                    </Stack>
                  </Stack>
                  <Box sx={{ px: 2, pt: 2 }}>
                    <Stack sx={summaryPanelStyles}>
                      <Stack direction={"row"} alignItems={"center"}>
                        <Typography
                          variant="subtitle1"
                          fontWeight={"medium"}
                          fontSize={"16px"}
                        >
                          Health Summary
                        </Typography>
                        <Stack direction={"row"} sx={{ ml: "auto" }}>
                          <Typography fontSize={"12px"}>View all</Typography>
                          <ArrowRightAlt sx={{ fontSize: "16px", ml: 0.5 }} />
                        </Stack>
                      </Stack>
                      <Stack
                        direction={"row"}
                        justifyContent={"space-between"}
                        sx={{ p: 1.5 }}
                      >
                        <Stack
                          direction={"column"}
                          gap={0.5}
                          alignItems={"center"}
                        >
                          <Avatar sx={{ width: "24px", height: "24px" }} />
                          <Typography variant="body1">
                            <strong>80</strong>
                          </Typography>
                        </Stack>
                        <Stack
                          direction={"column"}
                          gap={0.5}
                          alignItems={"center"}
                        >
                          <Avatar sx={{ width: "24px", height: "24px" }} />
                          <Typography variant="body1">
                            <strong>92 </strong>
                            mg/dl
                          </Typography>
                        </Stack>
                        <Stack
                          direction={"column"}
                          gap={0.5}
                          alignItems={"center"}
                        >
                          <Avatar sx={{ width: "24px", height: "24px" }} />
                          <Typography variant="body1">
                            <strong>7</strong>h <strong>25</strong>m
                          </Typography>
                        </Stack>
                      </Stack>
                    </Stack>
                  </Box>
                  <Stack
                    direction={"row"}
                    gap={0.5}
                    sx={{
                      mt: 2.5,
                      height: "40px",
                      overflowX: "hidden",
                      whiteSpace: "nowrap",
                      justifyContent: "flex-end",
                    }}
                  >
                    <Stack
                      direction={"row"}
                      alignItems={"center"}
                      sx={daySelectionItemStyles}
                      gap={0.5}
                    >
                      <Dot />
                      <Typography fontWeight={"light"} color={"#4a4f54"}>
                        Apr 4
                      </Typography>
                    </Stack>
                    <Stack
                      direction={"row"}
                      alignItems={"center"}
                      sx={daySelectionItemStyles}
                      gap={0.5}
                    >
                      <Dot />
                      <Typography fontWeight={"light"} color="#4a4f54">
                        Apr 3
                      </Typography>
                    </Stack>
                    <Stack
                      direction={"row"}
                      alignItems={"center"}
                      sx={daySelectionItemStyles}
                      gap={0.5}
                    >
                      <Dot />
                      <Typography fontWeight={"light"} color={"#4a4f54"}>
                        Apr 4
                      </Typography>
                    </Stack>
                    <Stack
                      direction={"row"}
                      alignItems={"center"}
                      sx={daySelectionItemStyles}
                      gap={0.5}
                    >
                      <Dot />
                      <Typography fontWeight={"light"} color="#4a4f54">
                        Apr 5
                      </Typography>
                    </Stack>
                    <Stack
                      direction={"row"}
                      alignItems={"center"}
                      sx={selectedDayStyles}
                      gap={0.5}
                    >
                      <SelectedDot />
                      <Typography fontWeight={"bold"} color={"#ff4713"}>
                        Yesterday
                      </Typography>
                    </Stack>
                    <Stack
                      direction={"row"}
                      alignItems={"center"}
                      sx={daySelectionItemStyles}
                      gap={0.5}
                    >
                      <Dot />
                      <Typography fontWeight={"light"} color={"#4a4f54"}>
                        Today
                      </Typography>
                    </Stack>
                  </Stack>
                  <Stack sx={{ px: 2, pt: 2 }}>
                    <Typography variant="h6" fontWeight={"bold"}>
                      To Do
                    </Typography>
                    <Box sx={{ mt: 2 }}>
                      <Stack
                        direction={"row"}
                        sx={toDoCardStyles}
                        alignItems={"center"}
                      >
                        <Avatar
                          sx={{
                            width: "40px",
                            height: "40px",
                            borderRadius: "12px",
                          }}
                        />
                        <Stack>
                          <Typography
                            variant="body1"
                            fontWeight={"medium"}
                            color={"#9AA0AA"}
                          >
                            Not Started
                          </Typography>
                          <Typography variant="body1" fontWeight={"bold"}>
                            <strong>GSE6 Questionnaire</strong>
                          </Typography>
                        </Stack>
                      </Stack>
                      <Stack
                        direction={"row"}
                        sx={{ ...toDoCardStyles, mt: 1.5 }}
                        alignItems={"center"}
                      >
                        <Avatar
                          sx={{
                            width: "40px",
                            height: "40px",
                            borderRadius: "12px",
                          }}
                        />
                        <Stack>
                          <Typography
                            variant="body1"
                            fontWeight={"medium"}
                            color={"#9AA0AA"}
                          >
                            Not Started
                          </Typography>
                          <Typography variant="body1" fontWeight={"bold"}>
                            <strong>BMSCS Questionnaire</strong>
                          </Typography>
                        </Stack>
                      </Stack>
                      <Stack
                        direction={"row"}
                        sx={{ ...toDoCardStyles, mt: 1.5 }}
                        alignItems={"center"}
                      >
                        <Avatar
                          sx={{
                            width: "40px",
                            height: "40px",
                            borderRadius: "12px",
                          }}
                        />
                        <Stack>
                          <Typography
                            variant="body1"
                            fontWeight={"medium"}
                            color={"#9AA0AA"}
                          >
                            Not Started
                          </Typography>
                          <Typography variant="body1" fontWeight={"bold"}>
                            <strong>BRSES Questionnaire</strong>
                          </Typography>
                        </Stack>
                      </Stack>
                    </Box>
                  </Stack>
                </>
                <>
                  <Stack
                    direction={"row"}
                    sx={appOptionsStyles}
                    gap={2.5}
                    p={0.2}
                  >
                    {previewData?.[0]?.enabled ? (
                      <Stack
                        alignItems={"center"}
                        sx={{ width: "36px", height: "36px" }}
                      >
                        <>
                          <Avatar
                            sx={{ width: "36px", height: "36px" }}
                            src={
                              previewData?.[0]?.activeIcon?.previewUrl ||
                              "path-to-active-icon"
                            }
                          />
                          <Typography
                            fontSize={"10px"}
                            color={"#ff4713"}
                            fontWeight={500}
                            maxWidth={"12ch"}
                            textOverflow={"ellipsis"}
                            whiteSpace={"nowrap"}
                          >
                            {previewData?.[0]?.text || "Home"}
                          </Typography>
                        </>
                      </Stack>
                    ) : null}
                    {/* {!previewData?.[0]?.enabled &&
                    previewData?.[1]?.enabled &&
                    previewData?.[2]?.enabled &&
                    previewData?.[3]?.enabled &&
                    previewData?.[4]?.enabled && (
                      <Stack sx={{ width: "36px", height: "36px" }} />
                    )} */}
                    {previewData?.[1]?.enabled ? (
                      <Stack
                        alignItems={"center"}
                        sx={{ width: "36px", height: "36px" }}
                      >
                        <>
                          <Avatar
                            sx={{ width: "36px", height: "36px" }}
                            src={
                              previewData?.[1]?.defaultIcon?.previewUrl ||
                              "path-to-default-icon"
                            }
                          />
                          <Typography
                            fontSize={"10px"}
                            fontWeight={500}
                            maxWidth={"12ch"}
                            textOverflow={"ellipsis"}
                            whiteSpace={"nowrap"}
                          >
                            {previewData?.[1]?.text || "Learn"}
                          </Typography>
                        </>
                      </Stack>
                    ) : null}
                    {/* {!previewData?.[1]?.enabled &&
                    previewData?.[2]?.enabled &&
                    previewData?.[3]?.enabled && (
                      <Stack sx={{ width: "36px", height: "36px" }} />
                    )} */}
                    {previewData?.[2]?.enabled ? (
                      <Stack
                        alignItems={"center"}
                        sx={
                          previewData?.[2]?.enabled
                            ? scanButtonWrapperStyles
                            : {
                                width: "36px",
                                height: "36px",
                              }
                        }
                      >
                        <Stack
                          sx={{
                            ...scanButtonInnerStyles,
                            width: "64px",
                            height: "64px",
                          }}
                        >
                          <Avatar
                            sx={{ width: "36px", height: "36px" }}
                            src={
                              previewData?.[2]?.defaultIcon?.previewUrl ||
                              "path-to-default-icon"
                            }
                          />
                          <Typography
                            fontSize={"10px"}
                            color={"#ff4713"}
                            fontWeight={500}
                            maxWidth={"12ch"}
                            textOverflow={"ellipsis"}
                            whiteSpace={"nowrap"}
                          >
                            {previewData?.[2]?.text || "Scan"}
                          </Typography>
                        </Stack>
                      </Stack>
                    ) : null}
                    {previewData?.[3]?.enabled ? (
                      <Stack
                        alignItems={"center"}
                        sx={{ width: "36px", height: "36px" }}
                      >
                        <>
                          <Avatar
                            sx={{ width: "36px", height: "36px" }}
                            src={
                              previewData?.[3]?.defaultIcon?.previewUrl ||
                              "path-to-default-icon"
                            }
                          />
                          <Typography
                            fontSize={"10px"}
                            fontWeight={500}
                            maxWidth={"12ch"}
                            textOverflow={"ellipsis"}
                            whiteSpace={"nowrap"}
                          >
                            {previewData?.[3]?.text || "Profile"}
                          </Typography>
                        </>
                      </Stack>
                    ) : null}
                    {/* {previewData?.[1]?.enabled &&
                    previewData?.[2]?.enabled &&
                    !previewData?.[3]?.enabled && (
                      <Stack sx={{ width: "36px", height: "36px" }} />
                    )} */}
                    {previewData?.[4]?.enabled ? (
                      <Stack
                        alignItems={"center"}
                        sx={{ width: "36px", height: "36px" }}
                      >
                        <>
                          <Avatar
                            sx={{ width: "36px", height: "36px" }}
                            src={
                              previewData?.[4]?.defaultIcon?.previewUrl ||
                              "path-to-default-icon"
                            }
                          />
                          <Typography
                            fontSize={"10px"}
                            fontWeight={500}
                            maxWidth={"12ch"}
                            textOverflow={"ellipsis"}
                            whiteSpace={"nowrap"}
                          >
                            {previewData?.[4]?.text || "Menu"}
                          </Typography>
                        </>
                      </Stack>
                    ) : null}
                    {/* {previewData?.[0]?.enabled &&
                    previewData?.[1]?.enabled &&
                    previewData?.[2]?.enabled &&
                    previewData?.[3]?.enabled &&
                    !previewData?.[4]?.enabled && (
                      <Stack sx={{ width: "36px", height: "36px" }} />
                    )} */}
                  </Stack>
                </>
              </>
            ) : (
              <Box
                sx={{
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress />
              </Box>
            )}
          </Stack>
        </MobileMockup>
      </Stack>
    </Box>
  );
};

export default HomeScreenPreview;
